module.exports = __webpack_public_path__ + "static/media/girl-1.1d79e382.svg";